// code will be called each time the user has to access a premium feature and we want to mae sure if he has an active subscription/license
import { useAuth } from '../../contexts/AuthContext';
import { useAuthModal } from '../../Components/Auth/AuthModalManager';

export const useMembershipGuard = () => {
  const { user, subscriptionActive } = useAuth();
  const { openLogin, openSubscribe } = useAuthModal();

  const executeMembershipGuard = (callback) => {
    if (!user) {
      openLogin();
      return;
    }

    if (!subscriptionActive) {
      openSubscribe();
      return;
    }

    // User has access, execute the callback
    callback();
  };

  return { executeMembershipGuard };
  // nienke updated 23 february because you want to add lock icons to eg. edit and save on mono tools
  // return { executeMembershipGuard, hasAccess: !!user && !!subscriptionActive };
};